import { render, staticRenderFns } from "./CommentTree.vue?vue&type=template&id=641551b8&scoped=true&"
import script from "./CommentTree.vue?vue&type=script&lang=js&"
export * from "./CommentTree.vue?vue&type=script&lang=js&"
import style0 from "./CommentTree.vue?vue&type=style&index=0&id=641551b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641551b8",
  null
  
)

export default component.exports